import _debounce from 'lodash/debounce';
import template from './tags.html';

class TagsComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    TagService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.TagService = TagService;
    this.columnKeys = ['name', 'studentsNumber'];
    this.loadPageCallbackWithDebounce = {};
    this.tags = {};
  }

  $onInit() {
    if (this.me.roleName === 'MANAGER' || this.me.roleName === 'HEAD_TEACHER') {
      this.columnKeys.push('id');
    }
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }
  }

  getLoadResultsCallback(loadPageCallback) {
    this.loadPageCallbackWithDebounce = _debounce(loadPageCallback, 1000);
  }

  paginatorCallback(page, limit) {
    let offset = ((page - 1) * limit) + 1;
    if (angular.isUndefined(offset) || isNaN(offset)) {
      offset = 1;
    }

    return this.TagService.list({
      offset,
      limit
    }, true).then(result => {
      this.tags = result.data;
      return {
        results: result.data,
        totalResultCount: result.metadata.total
      };
    });
  }

  addTag(ev) {
    const confirm = this.$mdDialog.prompt()
      .title('Dodaj nową etykietę')
      .textContent('Wpisz nazwę nowej etykiety.')
      .placeholder('Wpisz nazwę')
      .ariaLabel('Wpisz nazwę nowej etykiety.')
      .targetEvent(ev)
      .multiple(true)
      .ok('Zapisz')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(result => {
      const tag = [{
        name: result,
        students: []
      }];
      this.TagService.create(tag)
        .then(() => {
          this.loadPageCallbackWithDebounce();
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Dodano etykietę')
              .position('bottom right')
              .hideDelay(3000)
          );
        })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.newError({
              locals: {error}
            })
          );
        });
    });
  }

  edit(id, ev) {
    ev.stopPropagation();
    this.$state.go('modules.informations.tags.edit', {id});
  }

  remove(id, ev) {
    ev.stopPropagation();
    this.TagService.destroy(id).then(() => {
      this.loadPageCallbackWithDebounce();
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto etykietę')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.newError({
            locals: {error}
          })
        );
      });
  }
}

export const Tags = {
  bindings: {
    me: '<'
  },
  template,
  controller: TagsComponent
};
